<template>
    <div class="not-found">
        <div class="not-found-inner">
            <h1>404</h1>
            <p>请检查输入地址，或你没有权限访问该页面。</p>
            <el-button @click="jump" style="margin-top: 20px;" type="primary">返回上一页</el-button>
        </div>
    </div>
</template>
<script>
    export default {
        methods: {
            jump () {
                this.$router.go(-1);
            }
        }
    };
</script>
<style lang="scss">
    .not-found {
        width: 100%;
        height: 100%;
        position: relative;
        background: #2d3a4b;

        .el-button {
            height: 32px;
            line-height: 7px;

            a {
                text-decoration: none;
                color: white;
            }
        }

        h1 {
            font-size: 100px;
            margin-bottom: 0 !important;
            font-weight: bolder;
        }

        p {
            font-size: 14px;
            font-weight: bolder;
        }
    }

    .not-found {
        .not-found-inner {
            position: absolute;
            left: 50%;
            top: 20%;
            transform: translateX(-50%);
            animation: fadeIn 0.8s linear 0s;

            h1, p {
                color: white;
            }
        }
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
</style>